import { tableSchema } from '@nozbe/watermelondb'

export const milkDeliveriesSchema = tableSchema({
  name: 'milkDeliveries',
  columns: [
    { name: 'milkDeliveryId', type: 'string' },
    { name: 'dairyFarmId', type: 'string' },
    { name: 'condemnedVolume', type: 'number' },
    { name: 'manual', type: 'boolean' },
    { name: 'observation', type: 'string' },
    { name: 'organizationId', type: 'string' },
    { name: 'statusId', type: 'string' },
    { name: 'temperature', type: 'number' },
    { name: 'userId', type: 'string' },
    { name: 'userStateRegistrationId', type: 'string' },
    { name: 'volume', type: 'number' },
    { name: 'volumeDate', type: 'string' },
    { name: 'status', type: 'string' },
    { name: 'createdAt', type: 'string' },
    { name: 'updatedAt', type: 'string' }
  ]
})